import API from '@aws-amplify/api';
import Constant from '@/common/constant/Constant';
import { createKibanaLog } from '@/graphql/mutations';

export const createKibanaLogAPI = async (APIClient, params) => {
    try {
        let res = await API.graphql({
            query: createKibanaLog,
            variables: {
                params: JSON.stringify(params)
            },
            authMode: Constant.AUTH_MODE_API_KEY,
        });
        return res.data.createKibanaLog;
    } catch (err) {
        console.log('createKibanaLogAPI err ', err)
        return {};
    }
};
